<template>
  <div>
    <dw-survey-dcs-wrapper :id="id" is-answer-data="true" @getDate="setDate">
      <template v-slot:dw-dcs-main-slot="{ survey }">
        <div class="dw-dcs-main-title">
          <el-row type="flex">
            <el-col :span="18">
              <div style="font-size: 14px;padding: 10px;"><strong>原始数据列表</strong></div>
            </el-col>
            <el-col :span="6" style="text-align: right;padding-right: 16px;"><el-button type="primary" size="small" @click="handleExport">导出数据</el-button></el-col>
          </el-row>
        </div>
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.userName"></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.userName"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="学号">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.studentNumber"></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.studentNumber"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="手机号">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.phone"></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.phone"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="班级">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.className"></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.className"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="专业">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.majorName"></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.majorName"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="院系">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.depName"></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.depName"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="指导教师">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.teacherName"></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.teacherName"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="教师工号">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.teacherNumber"></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.teacherNumber"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="实习计划">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.planName"></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.planName"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="周次">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.weekNum"></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.weekNum"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="回答的题数">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.completeItemNum != null ? scope.row.completeItemNum : 0 }}&nbsp;题</span>
            </template>
          </el-table-column>
          <el-table-column label="回答时间">
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ scope.row.endAnDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip effect="dark" content="查看数据" placement="top">
                  <el-button size="mini" icon="el-icon-view" @click="handleGo(`/no-top/dw-survey/d/data/${scope.row.surveyId}/${scope.row.id}`)"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="删除数据" placement="top">
                  <el-button size="mini" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <div class="dw-pagination">
          <el-pagination :page-size="pageSize" :current-page="currentPage" :total="total" background layout="prev, pager, next,total" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </template>
    </dw-survey-dcs-wrapper>

    <el-dialog :visible.sync="dialogFormVisible" append-to-body title="导出答卷数据" width="40%">
      <div style="line-height: 30px;">导出文件将在后台异步进行,确定后请在《导出管理》中查询文件生成结果</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="executeExportData">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import DwSurveyDcsWrapper from '@/components/common/DwSurveyDcsWrapper'
import { dwSurveyAnswerList, dwSurveyAnswerDelete, dwSurveyAnswerExport } from '@/api/dw-survey'
export default {
  name: 'DwSurveyAnswer',
  components: {
    DwSurveyDcsWrapper
  },
  data() {
    return {
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      dialogFormVisible: false,
      expUpQu: 0,
      startTime: '',
      endTime: '',
      surveyId: ''
    }
  },
  mounted() {
    this.surveyId = this.$route.params.id
    this.queryList(1)
  },
  methods: {
    setDate(val) {
      this.startTime = val[0]
      this.endTime = val[1]
      this.queryList(1)
    },
    handleGo(to) {
      this.$router.push(to)
    },
    handlePush: function (to) {
      this.$router.push(to)
    },
    handleDelete(index, row) {
      console.log(index, row)
      this.$msgbox.confirm('确认删除此条答卷吗？', '删除警告', { type: 'warning', confirmButtonText: '确认删除' }).then(() => {
        const data = { id: [row.id] }
        dwSurveyAnswerDelete(data).then((response) => {
          console.log(response)
          const httpResult = response.data
          if (httpResult.resultCode === 200) {
            this.$message.success('删除成功，即将刷新数据。')
            this.queryList(1)
          } else {
            this.$message.error('删除答卷失败')
          }
        })
      }).catch(() => { })
    },
    handleCurrentChange(val) {
      this.queryList(val)
    },
    handleExport() {
      this.dialogFormVisible = true
    },
    executeExportData() {
      dwSurveyAnswerExport(this.surveyId, this.expUpQu, this.startTime, this.endTime).then((response) => {
        console.log(response)
        const httpResult = response.data
        if (httpResult.resultCode === 200) {
          this.$message.success(httpResult.data)
        } else {
          this.$message.error('导出失败')
        }
      })
      this.dialogFormVisible = false
    },
    queryList(pageNo) {
      dwSurveyAnswerList(this.pageSize, pageNo, this.surveyId, this.startTime, this.endTime).then((response) => {
        const resultData = response.data.data
        // const resultData = [
        //   {
        //     "id": "d1d55ed3-3d6c-4dd0-93a9-a2ea17f05702",
        //     "surveyId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //     "userId": "106294942",
        //     "bgAnDate": null,
        //     "endAnDate": "2024-10-25 17:52:26",
        //     "totalTime": 0,
        //     "ipAddr": "113.124.89.183",
        //     "addr": null,
        //     "city": null,
        //     "pcMac": null,
        //     "quNum": null,
        //     "isComplete": 1,
        //     "completeNum": null,
        //     "completeItemNum": 26,
        //     "isEffective": 1,
        //     "handleState": 0,
        //     "dataSource": 0,
        //     "phone": "18264242005",
        //     "depName": "机电工程系",
        //     "depId": "54c7e5aec90583e447a6e0f58a3d898e",
        //     "majorId": "839346a8387f4c108978a5e76b52d495",
        //     "majorName": "机电设备维修与管理",
        //     "classId": "34ddabd18a237ec45155e859d692250d",
        //     "className": "23机电三二连读班",
        //     "userName": "孙启山",
        //     "studentNumber": "236377",
        //     "schoolId": "1f7f45549a1e5c47ad8cfd260bd1f000",
        //     "schoolName": "山东轻工职业学院",
        //     "studentId": "cb24b45b8fa00d6b563df50df9e176aa",
        //     "teacherId": null,
        //     "teacherNumber": null,
        //     "teacherName": null,
        //     "planId": null,
        //     "planName": null,
        //     "weekTime": "2024-10-21 00:00:00",
        //     "weekNum": "第43周",
        //     "surveyDirectory": null
        //   },
        //   {
        //     "id": "525a450e-ac10-49ad-80f7-5ca1bce69d31",
        //     "surveyId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //     "userId": "106138772",
        //     "bgAnDate": null,
        //     "endAnDate": "2024-10-25 17:52:19",
        //     "totalTime": 0,
        //     "ipAddr": "112.227.203.8",
        //     "addr": null,
        //     "city": null,
        //     "pcMac": null,
        //     "quNum": null,
        //     "isComplete": 1,
        //     "completeNum": null,
        //     "completeItemNum": 26,
        //     "isEffective": 1,
        //     "handleState": 0,
        //     "dataSource": 0,
        //     "phone": "18769178931",
        //     "depName": "艺术设计系",
        //     "depId": "7b32ff1faba24b3cf7ca32ea25958708",
        //     "majorId": "52ec6b4b42c0915369519c7f30ab643b",
        //     "majorName": "艺术设计（室内方向）",
        //     "classId": "ceb5f8c69b58ca92eb24fc15c8dc46aa",
        //     "className": "22艺术室内二班",
        //     "userName": "牛思诺",
        //     "studentNumber": "236473",
        //     "schoolId": "1f7f45549a1e5c47ad8cfd260bd1f000",
        //     "schoolName": "山东轻工职业学院",
        //     "studentId": "b57cb9b96eab3d723426f87f3b4cedde",
        //     "teacherId": null,
        //     "teacherNumber": null,
        //     "teacherName": null,
        //     "planId": null,
        //     "planName": null,
        //     "weekTime": "2024-10-21 00:00:00",
        //     "weekNum": "第43周",
        //     "surveyDirectory": null
        //   },
        //   {
        //     "id": "7454fd54-e687-4b82-afb9-a24645da51fd",
        //     "surveyId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //     "userId": "106406952",
        //     "bgAnDate": null,
        //     "endAnDate": "2024-10-25 17:51:46",
        //     "totalTime": 0,
        //     "ipAddr": "111.36.192.209",
        //     "addr": null,
        //     "city": null,
        //     "pcMac": null,
        //     "quNum": null,
        //     "isComplete": 1,
        //     "completeNum": null,
        //     "completeItemNum": 26,
        //     "isEffective": 1,
        //     "handleState": 0,
        //     "dataSource": 0,
        //     "phone": "13853935945",
        //     "depName": "嘉环ICT产业学院",
        //     "depId": "b00ddf8d52df690f88e0cd8bec250562",
        //     "majorId": "46c4e4e84c0625578761b1f865021545",
        //     "majorName": "现代移动通信技术",
        //     "classId": "470c63b2d5a8cdd37eb80dca8267db8a",
        //     "className": "22移动通信嘉环二班",
        //     "userName": "杨传森",
        //     "studentNumber": "222108",
        //     "schoolId": "1f7f45549a1e5c47ad8cfd260bd1f000",
        //     "schoolName": "山东轻工职业学院",
        //     "studentId": "f2a1c78094b0dc2f1e80571ee2e8a7b7",
        //     "teacherId": null,
        //     "teacherNumber": null,
        //     "teacherName": null,
        //     "planId": null,
        //     "planName": null,
        //     "weekTime": "2024-10-21 00:00:00",
        //     "weekNum": "第43周",
        //     "surveyDirectory": null
        //   },
        //   {
        //     "id": "e44ba763-3ced-4d44-848a-a75c9d05ec02",
        //     "surveyId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //     "userId": "106646425",
        //     "bgAnDate": null,
        //     "endAnDate": "2024-10-25 17:50:49",
        //     "totalTime": 0,
        //     "ipAddr": "182.33.200.101",
        //     "addr": null,
        //     "city": null,
        //     "pcMac": null,
        //     "quNum": null,
        //     "isComplete": 1,
        //     "completeNum": null,
        //     "completeItemNum": 26,
        //     "isEffective": 1,
        //     "handleState": 0,
        //     "dataSource": 0,
        //     "phone": "17658616625",
        //     "depName": "健康管理系",
        //     "depId": "bbdb3292515f40a6907af4c8e0de6f3f",
        //     "majorId": "b40ada141f62446d800293b98d848540",
        //     "majorName": "婴幼儿托育服务与管理",
        //     "classId": "3f73f170872301623999394b8d064fc8",
        //     "className": "22婴幼儿托育四班",
        //     "userName": "张绮霞",
        //     "studentNumber": "222325",
        //     "schoolId": "1f7f45549a1e5c47ad8cfd260bd1f000",
        //     "schoolName": "山东轻工职业学院",
        //     "studentId": "4ef222f00305a5e34bdc954bf203f800",
        //     "teacherId": null,
        //     "teacherNumber": null,
        //     "teacherName": null,
        //     "planId": null,
        //     "planName": null,
        //     "weekTime": "2024-10-21 00:00:00",
        //     "weekNum": "第43周",
        //     "surveyDirectory": null
        //   },
        //   {
        //     "id": "461e8a15-478f-4375-b1ad-af1c1ef0d059",
        //     "surveyId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //     "userId": "106303923",
        //     "bgAnDate": null,
        //     "endAnDate": "2024-10-25 17:50:41",
        //     "totalTime": 0,
        //     "ipAddr": "223.104.191.37",
        //     "addr": null,
        //     "city": null,
        //     "pcMac": null,
        //     "quNum": null,
        //     "isComplete": 1,
        //     "completeNum": null,
        //     "completeItemNum": 26,
        //     "isEffective": 1,
        //     "handleState": 0,
        //     "dataSource": 0,
        //     "phone": "15953125279",
        //     "depName": "嘉环ICT产业学院",
        //     "depId": "b00ddf8d52df690f88e0cd8bec250562",
        //     "majorId": "79a88ca3e80543b5a1f54e546e8ce97e",
        //     "majorName": "软件技术",
        //     "classId": "21a29d23696a80c1d24f3cd2925f14fe",
        //     "className": "22软件嘉环二班",
        //     "userName": "杜雨嵩",
        //     "studentNumber": "224595",
        //     "schoolId": "1f7f45549a1e5c47ad8cfd260bd1f000",
        //     "schoolName": "山东轻工职业学院",
        //     "studentId": "3e63429e86c94afceeed466f03f9d561",
        //     "teacherId": null,
        //     "teacherNumber": null,
        //     "teacherName": null,
        //     "planId": null,
        //     "planName": null,
        //     "weekTime": "2024-10-21 00:00:00",
        //     "weekNum": "第43周",
        //     "surveyDirectory": null
        //   },
        //   {
        //     "id": "df01b4a6-783f-462c-a4dc-b3be1474272a",
        //     "surveyId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //     "userId": "106574519",
        //     "bgAnDate": null,
        //     "endAnDate": "2024-10-25 17:50:18",
        //     "totalTime": 0,
        //     "ipAddr": "144.52.144.115",
        //     "addr": null,
        //     "city": null,
        //     "pcMac": null,
        //     "quNum": null,
        //     "isComplete": 1,
        //     "completeNum": null,
        //     "completeItemNum": 26,
        //     "isEffective": 1,
        //     "handleState": 0,
        //     "dataSource": 0,
        //     "phone": "19963819967",
        //     "depName": "健康管理系",
        //     "depId": "bbdb3292515f40a6907af4c8e0de6f3f",
        //     "majorId": "b40ada141f62446d800293b98d848540",
        //     "majorName": "婴幼儿托育服务与管理",
        //     "classId": "18030533d16a967de35522df07d0a16d",
        //     "className": "22婴幼儿托育五班",
        //     "userName": "张筱梅",
        //     "studentNumber": "223808",
        //     "schoolId": "1f7f45549a1e5c47ad8cfd260bd1f000",
        //     "schoolName": "山东轻工职业学院",
        //     "studentId": "ec531253ae842c6a9905cd2eab33f171",
        //     "teacherId": null,
        //     "teacherNumber": null,
        //     "teacherName": null,
        //     "planId": null,
        //     "planName": null,
        //     "weekTime": "2024-10-21 00:00:00",
        //     "weekNum": "第43周",
        //     "surveyDirectory": null
        //   },
        //   {
        //     "id": "4d9754b6-cc03-4718-b87f-aee03ad21bea",
        //     "surveyId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //     "userId": "106404874",
        //     "bgAnDate": null,
        //     "endAnDate": "2024-10-25 17:49:26",
        //     "totalTime": 0,
        //     "ipAddr": "39.67.223.175",
        //     "addr": null,
        //     "city": null,
        //     "pcMac": null,
        //     "quNum": null,
        //     "isComplete": 1,
        //     "completeNum": null,
        //     "completeItemNum": 26,
        //     "isEffective": 1,
        //     "handleState": 0,
        //     "dataSource": 0,
        //     "phone": "18560523362",
        //     "depName": "嘉环ICT产业学院",
        //     "depId": "b00ddf8d52df690f88e0cd8bec250562",
        //     "majorId": "79a88ca3e80543b5a1f54e546e8ce97e",
        //     "majorName": "软件技术",
        //     "classId": "d448e4e1089ca4b254a4944bdfd1d7fc",
        //     "className": "22软件嘉环三班",
        //     "userName": "徐晨",
        //     "studentNumber": "223413",
        //     "schoolId": "1f7f45549a1e5c47ad8cfd260bd1f000",
        //     "schoolName": "山东轻工职业学院",
        //     "studentId": "bd205378c7cbc7efe7ad230b57a2ce53",
        //     "teacherId": null,
        //     "teacherNumber": null,
        //     "teacherName": null,
        //     "planId": null,
        //     "planName": null,
        //     "weekTime": "2024-10-21 00:00:00",
        //     "weekNum": "第43周",
        //     "surveyDirectory": null
        //   },
        //   {
        //     "id": "63aae2a1-aac4-42d0-9f7c-049abf49beb2",
        //     "surveyId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //     "userId": "106146418",
        //     "bgAnDate": null,
        //     "endAnDate": "2024-10-25 17:49:19",
        //     "totalTime": 0,
        //     "ipAddr": "113.122.241.0",
        //     "addr": null,
        //     "city": null,
        //     "pcMac": null,
        //     "quNum": null,
        //     "isComplete": 1,
        //     "completeNum": null,
        //     "completeItemNum": 26,
        //     "isEffective": 1,
        //     "handleState": 0,
        //     "dataSource": 0,
        //     "phone": "15266628229",
        //     "depName": "艺术设计系",
        //     "depId": "7b32ff1faba24b3cf7ca32ea25958708",
        //     "majorId": "2a7e93a0cbacd470dea91aa4d548af47",
        //     "majorName": "环境艺术设计",
        //     "classId": "131f1c87cabe64a649b075c81eda8a8c",
        //     "className": "22环境艺术二班",
        //     "userName": "谢雨桓",
        //     "studentNumber": "223874",
        //     "schoolId": "1f7f45549a1e5c47ad8cfd260bd1f000",
        //     "schoolName": "山东轻工职业学院",
        //     "studentId": "186119e4b21c49ae665735eb4efe9d6d",
        //     "teacherId": null,
        //     "teacherNumber": null,
        //     "teacherName": null,
        //     "planId": null,
        //     "planName": null,
        //     "weekTime": "2024-10-21 00:00:00",
        //     "weekNum": "第43周",
        //     "surveyDirectory": null
        //   },
        //   {
        //     "id": "e058b5c3-3a37-426a-83e8-cf82025a9f72",
        //     "surveyId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //     "userId": "106642750",
        //     "bgAnDate": null,
        //     "endAnDate": "2024-10-25 17:49:11",
        //     "totalTime": 0,
        //     "ipAddr": "112.38.127.92",
        //     "addr": null,
        //     "city": null,
        //     "pcMac": null,
        //     "quNum": null,
        //     "isComplete": 1,
        //     "completeNum": null,
        //     "completeItemNum": 26,
        //     "isEffective": 1,
        //     "handleState": 0,
        //     "dataSource": 0,
        //     "phone": "17806081982",
        //     "depName": "国际时尚学院",
        //     "depId": "6787dddc18e894445da90fa7d19a064d",
        //     "majorId": "17d024f3c572d9f281b68a39e38c38a5",
        //     "majorName": "服装与服饰设计",
        //     "classId": "f36cedfb9c3b45351959b3dea46c40b5",
        //     "className": "22服饰设计三班",
        //     "userName": "韩乐",
        //     "studentNumber": "220474",
        //     "schoolId": "1f7f45549a1e5c47ad8cfd260bd1f000",
        //     "schoolName": "山东轻工职业学院",
        //     "studentId": "ad1e66a4a3766af90e0769ccb264c2f3",
        //     "teacherId": null,
        //     "teacherNumber": null,
        //     "teacherName": null,
        //     "planId": null,
        //     "planName": null,
        //     "weekTime": "2024-10-21 00:00:00",
        //     "weekNum": "第43周",
        //     "surveyDirectory": null
        //   },
        //   {
        //     "id": "705b8681-1527-412c-a42a-530328508b78",
        //     "surveyId": "517cd206-b9e0-4f17-b195-3d6e3aae9fd6",
        //     "userId": "106380142",
        //     "bgAnDate": null,
        //     "endAnDate": "2024-10-25 17:47:05",
        //     "totalTime": 0,
        //     "ipAddr": "112.38.179.209",
        //     "addr": null,
        //     "city": null,
        //     "pcMac": null,
        //     "quNum": null,
        //     "isComplete": 1,
        //     "completeNum": null,
        //     "completeItemNum": 26,
        //     "isEffective": 1,
        //     "handleState": 0,
        //     "dataSource": 0,
        //     "phone": "18863452320",
        //     "depName": "工商管理系",
        //     "depId": "f2fffe2b75fb47666f8ccb1bdc4d7cce",
        //     "majorId": "9188b1e53db50ac08e0a55567fa24da2",
        //     "majorName": "大数据与会计",
        //     "classId": "40366e156e8ba63293a15421147d55f1",
        //     "className": "22会计三班",
        //     "userName": "朱瑞泽",
        //     "studentNumber": "224127",
        //     "schoolId": "1f7f45549a1e5c47ad8cfd260bd1f000",
        //     "schoolName": "山东轻工职业学院",
        //     "studentId": "cf935dcfd6fd368c6724cb949504439a",
        //     "teacherId": null,
        //     "teacherNumber": null,
        //     "teacherName": null,
        //     "planId": null,
        //     "planName": null,
        //     "weekTime": "2024-10-21 00:00:00",
        //     "weekNum": "第43周",
        //     "surveyDirectory": null
        //   }
        // ]
        this.tableData = resultData
        this.total = response.data.total
        this.currentPage = response.data.current
        this.pageSize = response.data.pageSize
      })
    }
  }
}

</script>
<style scoped>
.dw-pagination {
  padding-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/dw-survey/dw-data/DwSurveyAnswer.vue